<soho-header >
  <soho-toolbar-flex>
    <button soho-toolbar-flex-nav-button>Show Navigation</button>
    <soho-toolbar-flex-section [isTitle]="true">
      <div style="margin-top: 25px;">
      <div style="float: left;">
      <h2>
        <span id="PageTitle" soho-page-title (click)="RedirectToHome()" style="cursor: pointer;">Capacity Model</span>
      </h2>
      </div>
      <div style="float: right;" class="field" id="divFiscalYear">
        <label style="float: left;margin-right: 10px"> FY:</label>
        <select style="float: left;" id="FiscalYear"  name="FiscalYear" [(ngModel)]="headfiscalyear" (change)='onOptionsSelected()'  >
            <option value="-1" selected="">--Select--</option>
            <option value="FY20" selected="">FY20</option>
            <option value="FY20SY" selected="">FY20SY</option>
            <option value="CY21" selected="">CY21</option>
            <option value="CY22" selected="">CY22</option>
            <option value="CY23" selected="">CY23</option>
            <option value="CY24" selected="">CY24</option>
            <option value="CY25" selected="">CY25</option>
            <option value="CY26"  selected="">CY26</option>
            <option value="CY27"  >CY27</option>
        </select>
       </div>
      </div>
    </soho-toolbar-flex-section> 
  </soho-toolbar-flex>
</soho-header>